import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogTitle,
} from "alm-react-components";
import { t } from "i18next";
import { ReactElement } from "react";

type PropBasedAlertBoxProps={
  type?:any;
  message:any;
  title?:any;
  setVisible:any
}
export const PropBasedAlertBox = ({message,title,type,setVisible}:PropBasedAlertBoxProps) => {

  const onCancle = () => {
    setVisible(false)
  };

  return (<AlertDialog open={true}>
        <AlertDialogTitle></AlertDialogTitle>
        <AlertDialogContent className="bg-[#16171C] py-6 px-3 max-md:px-6 md:px-12 w-full text-center border border-primary overflow-hidden">        
          <AlertDialogDescription className="flex py-8 flex-col">
          <AlertBody type={type} heading={title} body={message} />
        </AlertDialogDescription>
        <AlertDialogFooter className="lg:justify-center z-[1]">
          <AlertDialogAction
            onClick={() => onCancle()}
            className="w-full font-opensansSemiBold text-base capitalize"
          >
            {" "}
            {t("Common.gotIt")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};


type DialogModalProps = { 
  type?: string;
  heading?: ReactElement | any;
  body: ReactElement | any;
};

const AlertBody: React.FC<DialogModalProps> = ({
  body,
}) => {
  return (<span className="text-2xl font-barlowRegular text-white">{body}</span>);
};